import { createContext, useContext, useState, useEffect } from "react";

export const TIMEZONES = [
  {label:"(UTC-12:00) International Date Line West", value:"Etc/GMT+12",             region:"Pacific"},
  {label:"(UTC-11:00) Coordinated Universal Time-11",value:"Pacific/Pago_Pago",      region:"Pacific"},
  {label:"(UTC-10:00) Hawaii",                       value:"Pacific/Honolulu",       region:"Pacific"},
  {label:"(UTC-09:00) Alaska",                       value:"America/Anchorage",      region:"Americas"},
  {label:"(UTC-08:00) Baja California",              value:"America/Santa_Isabel",   region:"Americas"},
  {label:"(UTC-08:00) Pacific Time (US & Canada)",   value:"America/Los_Angeles",    region:"Americas"},
  {label:"(UTC-07:00) Arizona",                      value:"America/Phoenix",        region:"Americas"},
  {label:"(UTC-07:00) Chihuahua, La Paz, Mazatlan",  value:"America/Chihuahua",      region:"Americas"},
  {label:"(UTC-07:00) Mountain Time (US & Canada)",  value:"America/Denver",         region:"Americas"},
  {label:"(UTC-06:00) Central America",              value:"America/Guatemala",      region:"Americas"},
  {label:"(UTC-06:00) Central Time (US & Canada)",   value:"America/Chicago",        region:"Americas"},
  {label:"(UTC-06:00) Guadalajara, Mexico City",     value:"America/Mexico_City",    region:"Americas"},
  {label:"(UTC-06:00) Saskatchewan",                 value:"America/Regina",         region:"Americas"},
  {label:"(UTC-05:00) Bogota, Lima, Quito",          value:"America/Bogota",         region:"Americas"},
  {label:"(UTC-05:00) Eastern Time (US & Canada)",   value:"America/New_York",       region:"Americas"},
  {label:"(UTC-05:00) Indiana (East)",               value:"America/Indiana/Indianapolis",region:"Americas"},
  {label:"(UTC-04:30) Caracas",                      value:"America/Caracas",        region:"Americas"},
  {label:"(UTC-04:00) Asuncion",                     value:"America/Asuncion",       region:"Americas"},
  {label:"(UTC-04:00) Atlantic Time (Canada)",       value:"America/Halifax",        region:"Americas"},
  {label:"(UTC-04:00) Cuiaba",                       value:"America/Cuiaba",         region:"Americas"},
  {label:"(UTC-04:00) Georgetown, La Paz, Manaus",   value:"America/La_Paz",         region:"Americas"},
  {label:"(UTC-04:00) Santiago",                     value:"America/Santiago",       region:"Americas"},
  {label:"(UTC-03:30) Newfoundland",                 value:"America/St_Johns",       region:"Americas"},
  {label:"(UTC-03:00) Brasilia",                     value:"America/Sao_Paulo",      region:"Americas"},
  {label:"(UTC-03:00) Buenos Aires",                 value:"America/Argentina/Buenos_Aires",region:"Americas"},
  {label:"(UTC-03:00) Cayenne, Fortaleza",           value:"America/Cayenne",        region:"Americas"},
  {label:"(UTC-03:00) Greenland",                    value:"America/Godthab",        region:"Americas"},
  {label:"(UTC-03:00) Montevideo",                   value:"America/Montevideo",     region:"Americas"},
  {label:"(UTC-02:00) Coordinated Universal Time-02",value:"Etc/GMT+2",              region:"Atlantic"},
  {label:"(UTC-01:00) Azores",                       value:"Atlantic/Azores",        region:"Atlantic"},
  {label:"(UTC-01:00) Cape Verde Is.",               value:"Atlantic/Cape_Verde",    region:"Atlantic"},
  {label:"(UTC) Casablanca",                         value:"Africa/Casablanca",      region:"Africa"},
  {label:"(UTC) Coordinated Universal Time",         value:"UTC",                    region:"Universal"},
  {label:"(UTC) Dublin, Edinburgh, Lisbon, London",  value:"Europe/London",          region:"Europe"},
  {label:"(UTC) Monrovia, Reykjavik",                value:"Atlantic/Reykjavik",     region:"Europe"},
  {label:"(UTC+01:00) Amsterdam, Berlin, Bern, Rome",value:"Europe/Amsterdam",       region:"Europe"},
  {label:"(UTC+01:00) Belgrade, Bratislava, Budapest",value:"Europe/Belgrade",       region:"Europe"},
  {label:"(UTC+01:00) Brussels, Copenhagen, Madrid", value:"Europe/Brussels",        region:"Europe"},
  {label:"(UTC+01:00) Sarajevo, Skopje, Warsaw",     value:"Europe/Sarajevo",        region:"Europe"},
  {label:"(UTC+01:00) West Central Africa",          value:"Africa/Lagos",           region:"Africa"},
  {label:"(UTC+01:00) Windhoek",                     value:"Africa/Windhoek",        region:"Africa"},
  {label:"(UTC+02:00) Amman",                        value:"Asia/Amman",             region:"Middle East"},
  {label:"(UTC+02:00) Athens, Bucharest",            value:"Europe/Athens",          region:"Europe"},
  {label:"(UTC+02:00) Beirut",                       value:"Asia/Beirut",            region:"Middle East"},
  {label:"(UTC+02:00) Cairo",                        value:"Africa/Cairo",           region:"Africa"},
  {label:"(UTC+02:00) Damascus",                     value:"Asia/Damascus",          region:"Middle East"},
  {label:"(UTC+02:00) Harare, Pretoria",             value:"Africa/Johannesburg",    region:"Africa"},
  {label:"(UTC+02:00) Helsinki, Kyiv, Riga, Sofia",  value:"Europe/Helsinki",        region:"Europe"},
  {label:"(UTC+02:00) Istanbul",                     value:"Europe/Istanbul",        region:"Europe"},
  {label:"(UTC+02:00) Jerusalem",                    value:"Asia/Jerusalem",         region:"Middle East"},
  {label:"(UTC+02:00) Tripoli",                      value:"Africa/Tripoli",         region:"Africa"},
  {label:"(UTC+03:00) Baghdad",                      value:"Asia/Baghdad",           region:"Middle East"},
  {label:"(UTC+03:00) Kuwait, Riyadh",               value:"Asia/Riyadh",            region:"Middle East"},
  {label:"(UTC+03:00) Minsk",                        value:"Europe/Minsk",           region:"Europe"},
  {label:"(UTC+03:00) Moscow, St. Petersburg",       value:"Europe/Moscow",          region:"Europe"},
  {label:"(UTC+03:00) Nairobi",                      value:"Africa/Nairobi",         region:"Africa"},
  {label:"(UTC+03:30) Tehran",                       value:"Asia/Tehran",            region:"Middle East"},
  {label:"(UTC+04:00) Abu Dhabi, Muscat",            value:"Asia/Dubai",             region:"Middle East"},
  {label:"(UTC+04:00) Baku",                         value:"Asia/Baku",              region:"Asia"},
  {label:"(UTC+04:00) Port Louis",                   value:"Indian/Mauritius",       region:"Asia"},
  {label:"(UTC+04:00) Tbilisi",                      value:"Asia/Tbilisi",           region:"Asia"},
  {label:"(UTC+04:00) Yerevan",                      value:"Asia/Yerevan",           region:"Asia"},
  {label:"(UTC+04:30) Kabul",                        value:"Asia/Kabul",             region:"Asia"},
  {label:"(UTC+05:00) Ashgabat, Tashkent",           value:"Asia/Tashkent",          region:"Asia"},
  {label:"(UTC+05:00) Islamabad, Karachi",           value:"Asia/Karachi",           region:"Asia"},
  {label:"(UTC+05:00) Yekaterinburg",                value:"Asia/Yekaterinburg",     region:"Asia"},
  {label:"(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",value:"Asia/Kolkata",     region:"Asia"},
  {label:"(UTC+05:30) Sri Jayawardenepura",          value:"Asia/Colombo",           region:"Asia"},
  {label:"(UTC+05:45) Kathmandu",                    value:"Asia/Kathmandu",         region:"Asia"},
  {label:"(UTC+06:00) Astana",                       value:"Asia/Dhaka",             region:"Asia"},
  {label:"(UTC+06:00) Dhaka",                        value:"Asia/Dhaka",             region:"Asia"},
  {label:"(UTC+06:00) Novosibirsk",                  value:"Asia/Novosibirsk",       region:"Asia"},
  {label:"(UTC+06:30) Yangon (Rangoon)",             value:"Asia/Rangoon",           region:"Asia"},
  {label:"(UTC+07:00) Bangkok, Hanoi, Jakarta",      value:"Asia/Bangkok",           region:"Asia"},
  {label:"(UTC+07:00) Krasnoyarsk",                  value:"Asia/Krasnoyarsk",       region:"Asia"},
  {label:"(UTC+07:00) Novosibirsk",                  value:"Asia/Novosibirsk",       region:"Asia"},
  {label:"(UTC+07:00) Tomsk",                        value:"Asia/Tomsk",             region:"Asia"},
  {label:"(UTC+08:00) Beijing, Chongqing, Hong Kong",value:"Asia/Shanghai",          region:"Asia"},
  {label:"(UTC+08:00) Irkutsk",                      value:"Asia/Irkutsk",           region:"Asia"},
  {label:"(UTC+08:00) Kuala Lumpur, Singapore",      value:"Asia/Singapore",         region:"Asia"},
  {label:"(UTC+08:00) Perth",                        value:"Australia/Perth",        region:"Pacific"},
  {label:"(UTC+08:00) Taipei",                       value:"Asia/Taipei",            region:"Asia"},
  {label:"(UTC+08:00) Ulaanbaatar",                  value:"Asia/Ulaanbaatar",       region:"Asia"},
  {label:"(UTC+09:00) Osaka, Sapporo, Tokyo",        value:"Asia/Tokyo",             region:"Asia"},
  {label:"(UTC+09:00) Seoul",                        value:"Asia/Seoul",             region:"Asia"},
  {label:"(UTC+09:00) Yakutsk",                      value:"Asia/Yakutsk",           region:"Asia"},
  {label:"(UTC+09:30) Adelaide",                     value:"Australia/Adelaide",     region:"Pacific"},
  {label:"(UTC+09:30) Darwin",                       value:"Australia/Darwin",       region:"Pacific"},
  {label:"(UTC+10:00) Brisbane",                     value:"Australia/Brisbane",     region:"Pacific"},
  {label:"(UTC+10:00) Canberra, Melbourne, Sydney",  value:"Australia/Sydney",       region:"Pacific"},
  {label:"(UTC+10:00) Guam, Port Moresby",           value:"Pacific/Guam",           region:"Pacific"},
  {label:"(UTC+10:00) Hobart",                       value:"Australia/Hobart",       region:"Pacific"},
  {label:"(UTC+10:00) Vladivostok",                  value:"Asia/Vladivostok",       region:"Asia"},
  {label:"(UTC+11:00) Chokurdakh",                   value:"Asia/Srednekolymsk",     region:"Asia"},
  {label:"(UTC+11:00) Magadan",                      value:"Asia/Magadan",           region:"Asia"},
  {label:"(UTC+11:00) Solomon Is., New Caledonia",   value:"Pacific/Guadalcanal",    region:"Pacific"},
  {label:"(UTC+12:00) Auckland, Wellington",         value:"Pacific/Auckland",       region:"Pacific"},
  {label:"(UTC+12:00) Coordinated Universal Time+12",value:"Etc/GMT-12",             region:"Pacific"},
  {label:"(UTC+12:00) Fiji",                         value:"Pacific/Fiji",           region:"Pacific"},
  {label:"(UTC+12:00) Petropavlovsk-Kamchatsky",     value:"Asia/Kamchatka",         region:"Asia"},
  {label:"(UTC+13:00) Nuku'alofa",                   value:"Pacific/Tongatapu",      region:"Pacific"},
  {label:"(UTC+13:00) Samoa",                        value:"Pacific/Apia",           region:"Pacific"},
];

export function formatInTz(dateStr, timeStr, tz){
  try{
    if(!timeStr) return "";
    if(tz==="local") return new Date(`${dateStr}T${timeStr}:00`).toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",hour12:true});
    return new Date(`${dateStr}T${timeStr}:00`).toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",hour12:true,timeZone:tz});
  }catch(e){return timeStr;}
}

export function nowInTz(tz){
  try{
    if(tz==="local") return new Date().toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",second:"2-digit",hour12:true});
    return new Date().toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",second:"2-digit",hour12:true,timeZone:tz});
  }catch(e){return "";}
}

export function dateInTz(tz){
  try{
    if(tz==="local") return new Date().toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});
    return new Date().toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",timeZone:tz});
  }catch(e){return "";}
}

const TimezoneContext = createContext({
  timezone:"Asia/Kolkata",
  setTimezone:()=>{},
  tzLabel:"IST  India",
  tzNow:"",
  tzDate:"",
});

export function TimezoneProvider({children}){
  const saved = localStorage.getItem("sdr_timezone")||"Asia/Kolkata";
  const [timezone, setTimezoneState] = useState(saved);
  const [tzNow, setTzNow] = useState(nowInTz(saved));
  const [tzDate, setTzDate] = useState(dateInTz(saved));

  const setTimezone = (tz) => {
    setTimezoneState(tz);
    localStorage.setItem("sdr_timezone", tz);
  };

  useEffect(()=>{
    const tick=()=>{
      setTzNow(nowInTz(timezone));
      setTzDate(dateInTz(timezone));
    };
    tick();
    const t=setInterval(tick,1000);
    return()=>clearInterval(t);
  },[timezone]);

  const tzLabel = TIMEZONES.find(t=>t.value===timezone)?.label || timezone;

  return(
    <TimezoneContext.Provider value={{timezone,setTimezone,tzLabel,tzNow,tzDate}}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTz(){ return useContext(TimezoneContext); }

//  Universal Timezone Selector Widget 
export function TimezoneSelector({compact=false}){
  const {timezone, setTimezone, tzLabel, tzNow, tzDate} = useTz();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const regions=[...new Set(TIMEZONES.map(t=>t.region))];
  const filtered = TIMEZONES.filter(t=>
    !search || t.label.toLowerCase().includes(search.toLowerCase()) || t.region.toLowerCase().includes(search.toLowerCase())
  );

  return(
    <div style={{position:"relative",fontFamily:"'Segoe UI',sans-serif"}}>
      <button onClick={()=>setOpen(!open)}
        style={{display:"flex",alignItems:"center",gap:8,padding:compact?"5px 12px":"7px 14px",background:open?"#EBF3FB":"#fff",border:`1.5px solid ${open?"#0078D4":"#E2E6F0"}`,borderRadius:8,cursor:"pointer",color:"#1B1F2E",boxShadow:open?"0 0 0 3px #0078D418":"0 1px 3px rgba(0,0,0,.06)",transition:"all .15s",fontFamily:"'Segoe UI',sans-serif"}}
        onMouseEnter={e=>{e.currentTarget.style.borderColor="#0078D4";e.currentTarget.style.boxShadow="0 0 0 3px #0078D418";}}
        onMouseLeave={e=>{if(!open){e.currentTarget.style.borderColor="#E2E6F0";e.currentTarget.style.boxShadow="0 1px 3px rgba(0,0,0,.06)";}}}>
        <div style={{width:24,height:24,borderRadius:6,background:"#EBF3FB",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}></div>
        <div style={{textAlign:"left"}}>
          <div style={{fontSize:12,fontWeight:600,color:"#1B1F2E",lineHeight:1.3}}>{tzLabel.split("")[0].trim()}</div>
          {!compact&&<div style={{fontSize:10,color:"#0078D4",fontWeight:700,fontFamily:"monospace",lineHeight:1.2}}>{tzNow}</div>}
        </div>
        <div style={{width:16,height:16,borderRadius:4,background:"#F0F4FF",display:"flex",alignItems:"center",justifyContent:"center",marginLeft:2}}>
          <span style={{fontSize:8,color:"#4A5078",transform:open?"rotate(180deg)":"rotate(0deg)",display:"inline-block",transition:"transform .15s"}}></span>
        </div>
      </button>

      {open&&(
        <>
          <div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,zIndex:9998}}/>
          <div style={{position:"absolute",right:0,top:"calc(100% + 8px)",background:"#fff",border:"1px solid #E2E6F0",borderRadius:12,boxShadow:"0 20px 60px rgba(0,0,0,.15),0 4px 12px rgba(0,0,0,.08)",zIndex:9999,width:360,overflow:"hidden"}}>
            {/* Header */}
            <div style={{background:"linear-gradient(135deg,#0078D4,#106EBE)",padding:"14px 16px",position:"relative",overflow:"hidden"}}>
              <div style={{position:"absolute",top:-20,right:-20,width:80,height:80,borderRadius:"50%",background:"rgba(255,255,255,.08)"}}/>
              <div style={{position:"absolute",bottom:-30,right:20,width:60,height:60,borderRadius:"50%",background:"rgba(255,255,255,.06)"}}/>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                <div style={{width:32,height:32,borderRadius:8,background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}></div>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:"#fff"}}>Select Timezone</div>
                  <div style={{fontSize:11,color:"rgba(255,255,255,.75)"}}>Platform-wide setting</div>
                </div>
              </div>
              <div style={{background:"rgba(255,255,255,.12)",borderRadius:8,padding:"8px 12px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <div style={{fontSize:10,color:"rgba(255,255,255,.7)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:2}}>Currently selected</div>
                  <div style={{fontSize:13,fontWeight:700,color:"#fff"}}>{tzLabel}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:10,color:"rgba(255,255,255,.7)",marginBottom:2}}>{tzDate}</div>
                  <div style={{fontSize:16,fontWeight:700,color:"#fff",fontFamily:"monospace"}}>{tzNow}</div>
                </div>
              </div>
            </div>

            {/* Search */}
            <div style={{padding:"10px 12px",borderBottom:"1px solid #F0F4FF",background:"#FAFBFF"}}>
              <div style={{position:"relative"}}>
                <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:13,color:"#8890B0"}}></span>
                <input value={search} onChange={e=>setSearch(e.target.value)}
                  placeholder="Search timezone or region..."
                  autoFocus
                  style={{width:"100%",border:"1.5px solid #E2E6F0",borderRadius:8,padding:"7px 10px 7px 32px",fontSize:12,color:"#1B1F2E",outline:"none",boxSizing:"border-box",background:"#fff",fontFamily:"'Segoe UI',sans-serif",transition:"border-color .15s"}}
                  onFocus={e=>e.target.style.borderColor="#0078D4"}
                  onBlur={e=>e.target.style.borderColor="#E2E6F0"}/>
              </div>
            </div>

            {/* List */}
            <div style={{maxHeight:280,overflowY:"auto"}}>
              {(search?[null]:regions).map(region=>{
                const items=region?TIMEZONES.filter(t=>t.region===region):filtered;
                if(items.length===0)return null;
                return(
                  <div key={region||"all"}>
                    {region&&!search&&(
                      <div style={{padding:"8px 16px 4px",fontSize:10,fontWeight:700,color:"#8890B0",textTransform:"uppercase",letterSpacing:".7px",background:"#F8F9FB",borderBottom:"1px solid #F0F4FF"}}>
                        {region}
                      </div>
                    )}
                    {items.map(tz=>{
                      const isSelected=timezone===tz.value;
                      const t=nowInTz(tz.value);
                      return(
                        <button key={tz.value}
                          onClick={()=>{setTimezone(tz.value);setOpen(false);setSearch("");}}
                          style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 16px",border:"none",background:isSelected?"#EBF3FB":"transparent",cursor:"pointer",textAlign:"left",borderLeft:isSelected?"3px solid #0078D4":"3px solid transparent",transition:"background .1s"}}
                          onMouseEnter={e=>{if(!isSelected)e.currentTarget.style.background="#F5F8FF";}}
                          onMouseLeave={e=>{if(!isSelected)e.currentTarget.style.background="transparent";}}>
                          <div style={{display:"flex",alignItems:"center",gap:10}}>
                            <div style={{width:20,height:20,borderRadius:"50%",background:isSelected?"#0078D4":"#E2E6F0",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"background .1s"}}>
                              {isSelected&&<span style={{fontSize:10,color:"#fff"}}></span>}
                            </div>
                            <div>
                              <div style={{fontSize:12,fontWeight:isSelected?600:400,color:isSelected?"#0078D4":"#1B1F2E",lineHeight:1.3}}>{tz.label.split("")[0].trim()}</div>
                              {tz.label.includes("")&&<div style={{fontSize:10,color:"#8890B0",lineHeight:1.2}}>{tz.label.split("")[1]?.trim()}</div>}
                            </div>
                          </div>
                          <div style={{textAlign:"right",flexShrink:0}}>
                            <div style={{fontSize:12,color:isSelected?"#0078D4":"#4A5078",fontFamily:"monospace",fontWeight:isSelected?700:500}}>{t}</div>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div style={{padding:"10px 16px",borderTop:"1px solid #E2E6F0",background:"#F8F9FB",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{width:6,height:6,borderRadius:"50%",background:"#107C10",display:"inline-block"}}/>
                <span style={{fontSize:11,color:"#4A5078"}}>Saved to preferences</span>
              </div>
              <button onClick={()=>{setTimezone("local");setOpen(false);}}
                style={{background:"none",border:"1px solid #E2E6F0",borderRadius:6,color:"#0078D4",fontSize:11,cursor:"pointer",padding:"4px 10px",fontFamily:"'Segoe UI',sans-serif",fontWeight:500}}>
                Reset to Local
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}